import React from 'react';

export const SnippetsListPanel = () => {
	// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
	return <div>Coming soon</div>;
};
